export const hasRole = (user, roles) => {
  if (!user) {
    return false;
  }

  const userRoles = user.roles || [];
  const rolesIntersection = roles.filter((x) => userRoles.includes(x));
  return Boolean(rolesIntersection.length);
};
